import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["mobile"],
    _excluded2 = ["mobile", "code"],
    _excluded3 = ["provider"],
    _excluded4 = ["provider"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { config } from "./chunk-5XJQLH56.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/session.ts

var session_exports = {};

__export(session_exports, {
  accountLogin: function accountLogin() {
    return _accountLogin;
  },
  appleLogin: function appleLogin() {
    return _appleLogin;
  },
  bindAppleId: function bindAppleId() {
    return _bindAppleId;
  },
  bindWechatId: function bindWechatId() {
    return _bindWechatId;
  },
  bind_mdf_identity: function bind_mdf_identity() {
    return _bind_mdf_identity;
  },
  deactivateAccount: function deactivateAccount() {
    return _deactivateAccount;
  },
  emailLogin: function emailLogin() {
    return _emailLogin;
  },
  fbLogin: function fbLogin() {
    return _fbLogin;
  },
  getAccessTokenFromProvider: function getAccessTokenFromProvider() {
    return _getAccessTokenFromProvider;
  },
  getHasuraToken: function getHasuraToken() {
    return _getHasuraToken;
  },
  getMobileSmsCode: function getMobileSmsCode() {
    return _getMobileSmsCode;
  },
  getOmronToken: function getOmronToken() {
    return _getOmronToken;
  },
  logout: function logout() {
    return _logout;
  },
  mdfMobileBind: function mdfMobileBind() {
    return _mdfMobileBind;
  },
  mobileLogin: function mobileLogin() {
    return _mobileLogin;
  },
  mobileRegister: function mobileRegister() {
    return _mobileRegister;
  },
  mobileSmsBind: function mobileSmsBind() {
    return _mobileSmsBind;
  },
  mobileSmsLogin: function mobileSmsLogin() {
    return _mobileSmsLogin;
  },
  providerBinding: function providerBinding() {
    return _providerBinding;
  },
  providerLogin: function providerLogin() {
    return _providerLogin;
  },
  register: function register() {
    return _register;
  },
  resetPassword: function resetPassword() {
    return _resetPassword;
  },
  setMobilePassword: function setMobilePassword() {
    return _setMobilePassword;
  },
  verifyQrSession: function verifyQrSession() {
    return _verifyQrSession;
  },
  wechatLogin: function wechatLogin() {
    return _wechatLogin;
  }
});

var app_name = config.appName;

var _accountLogin = function _accountLogin(_ref) {
  var account = _ref.account,
      password = _ref.password;
  return fetcher_default.post("/v4/clients/sign_in", {
    app_name: app_name,
    source: "cofit",
    identity_number: account,
    password: password,
    birthday: password
  }).then(function (data) {
    var access_token = data.access_token,
        mdf_identity_id = data.mdf_identity_id,
        message = data.message;
    return {
      access_token: access_token,
      mdf_identity_id: mdf_identity_id,
      message: message
    };
  });
};

var _emailLogin = function _emailLogin(_ref2) {
  var account = _ref2.account,
      password = _ref2.password;
  return fetcher_default.post("/v4/clients/sign_in", {
    app_name: app_name,
    source: "cofit",
    email: account,
    password: password
  }).then(function (data) {
    return data.access_token;
  });
};

var _fbLogin = function _fbLogin(token) {
  return fetcher_default.get("/v4/auth/facebook_access_token/callback", {
    app_name: app_name,
    access_token: token
  }).then(function (data) {
    return data.access_token;
  });
};

var _wechatLogin = function _wechatLogin(_ref3) {
  var code = _ref3.code,
      mobileRequired = _ref3.mobileRequired;
  return fetcher_default.post("/v4/clients/wechat_code_sign_in", {
    app_name: app_name,
    code: code,
    mobile_required: mobileRequired
  });
};

var _bindWechatId = function _bindWechatId(_ref4) {
  var identityId = _ref4.identityId;
  return fetcher_default.post("/v4/clients/bind_wechat_identity", {
    app_name: app_name,
    identity_id: identityId
  });
};

var _appleLogin = function _appleLogin(_ref5) {
  var code = _ref5.code,
      mobileRequired = _ref5.mobileRequired,
      client_info = _ref5.client_info;
  return fetcher_default.post("/v4/clients/apple_code_sign_in", {
    app_name: app_name,
    code: code,
    client_info: client_info,
    mobile_required: mobileRequired
  });
};

var _bindAppleId = function _bindAppleId(_ref6) {
  var identityId = _ref6.identityId;
  return fetcher_default.post("/v4/clients/bind_apple_identity", {
    app_name: app_name,
    identity_id: identityId
  });
};

var _register = function _register(_ref7) {
  var account = _ref7.account,
      password = _ref7.password,
      name = _ref7.name,
      mobile = _ref7.mobile,
      gender = _ref7.gender;
  return fetcher_default.post("/v4/clients/sign_up", {
    app_name: app_name,
    source: "cofit",
    email: account,
    password: password,
    name: name,
    mobile: mobile,
    last_name: name,
    first_name: "",
    nick_name: name,
    real_name: name,
    gender: gender || "female"
  });
};

var _resetPassword = function _resetPassword(_ref8) {
  var inputValue = _ref8.inputValue;
  return fetcher_default.post("/v4/clients/reset_password", {
    app_name: app_name,
    source: "cofit",
    email: inputValue,
    identity_number: inputValue
  });
};

var _logout = function _logout(_ref9) {
  var uuid = _ref9.uuid,
      appPackageName = _ref9.appPackageName;
  return fetcher_default.post("/v4/clients/sign_out", {
    app_name: app_name,
    device_info: {
      uuid: uuid,
      appPackageName: appPackageName
    }
  });
};

var _mobileLogin = function _mobileLogin(_ref10) {
  var mobile = _ref10.mobile,
      password = _ref10.password;
  return fetcher_default.post("/v4/clients/mobile_sign_in", {
    app_name: app_name,
    mobile: mobile,
    password: password
  });
};

var _mobileRegister = function _mobileRegister(_ref11) {
  var mobile = _ref11.mobile,
      password = _ref11.password;
  return fetcher_default.post("/v4/clients/register_mobile", {
    app_name: app_name,
    mobile: mobile,
    password: password
  });
};

var _mobileSmsLogin = function _mobileSmsLogin(_ref12) {
  var mobile = _ref12.mobile,
      code = _ref12.code;
  return fetcher_default.post("/v4/clients/register_mobile_with_code", {
    app_name: app_name,
    mobile: mobile,
    code: code
  });
};

var _getAccessTokenFromProvider = function _getAccessTokenFromProvider(_ref13) {
  var encrypted_token = _ref13.encrypted_token,
      provider = _ref13.provider;
  return fetcher_default.post("/v4/clients/provider_sign_in", {
    encrypted_token: encrypted_token,
    provider: provider,
    app_name: app_name
  });
};

var _getMobileSmsCode = function _getMobileSmsCode(_ref14) {
  var mobile = _ref14.mobile,
      rest = _objectWithoutProperties(_ref14, _excluded);

  return fetcher_default.post("/v4/clients/mobile_sms_code", _objectSpread({
    app_name: app_name,
    mobile: mobile
  }, rest));
};

var _mobileSmsBind = function _mobileSmsBind(_ref15) {
  var mobile = _ref15.mobile,
      code = _ref15.code,
      rest = _objectWithoutProperties(_ref15, _excluded2);

  return fetcher_default.post("/v4/clients/bind_mobile_with_code", _objectSpread({
    app_name: app_name,
    mobile: mobile,
    code: code
  }, rest));
};

var _mdfMobileBind = function _mdfMobileBind(_ref16) {
  var mobile = _ref16.mobile,
      code = _ref16.code,
      mdf_identity_id = _ref16.mdf_identity_id;
  return fetcher_default.post("/v4/mdf/register_mobile_and_bind_mdf_identity", {
    app_name: app_name,
    mobile: mobile,
    mdf_identity_id: mdf_identity_id,
    code: code
  });
};

var _bind_mdf_identity = function _bind_mdf_identity(_ref17) {
  var account = _ref17.account,
      password = _ref17.password;
  return fetcher_default.post("/v4/mdf/bind_mdf_identity", {
    app_name: app_name,
    identity_number: account,
    password: password
  });
};

var _setMobilePassword = function _setMobilePassword(_ref18) {
  var mobile = _ref18.mobile,
      password = _ref18.password;
  return fetcher_default.post("/v4/clients/set_mobile_password", {
    app_name: app_name,
    mobile: mobile,
    password: password
  });
};

var _verifyQrSession = function _verifyQrSession(_ref19) {
  var id = _ref19.id,
      secret = _ref19.secret;
  return fetcher_default.post("/v4/qr_sessions/".concat(id, "/verify"), {
    app_name: app_name,
    secret: secret
  });
};

var _getOmronToken = function _getOmronToken(param) {
  return fetcher_default.get("/v4/omron/sign_in_url");
};

var _providerBinding = function _providerBinding(_ref20) {
  var provider = _ref20.provider,
      payload = _objectWithoutProperties(_ref20, _excluded3);

  return fetcher_default.post("/v4/clients/bind_provider", {
    app_name: app_name,
    provider: provider,
    payload: payload
  });
};

var _providerLogin = function _providerLogin(_ref21) {
  var provider = _ref21.provider,
      payload = _objectWithoutProperties(_ref21, _excluded4);

  return fetcher_default.post("/v4/clients/provider_sign_in", {
    app_name: app_name,
    provider: provider,
    payload: payload
  });
};

var _getHasuraToken = function _getHasuraToken() {
  return fetcher_default.get("/v4/clients/hasura_token", {
    app_name: app_name
  });
};

var _deactivateAccount = function _deactivateAccount() {
  return fetcher_default.post("/v4/clients/deactivate_account", {
    app_name: app_name
  });
};

export { _accountLogin as accountLogin, _emailLogin as emailLogin, _fbLogin as fbLogin, _wechatLogin as wechatLogin, _bindWechatId as bindWechatId, _appleLogin as appleLogin, _bindAppleId as bindAppleId, _register as register, _resetPassword as resetPassword, _logout as logout, _mobileLogin as mobileLogin, _mobileRegister as mobileRegister, _mobileSmsLogin as mobileSmsLogin, _getAccessTokenFromProvider as getAccessTokenFromProvider, _getMobileSmsCode as getMobileSmsCode, _mobileSmsBind as mobileSmsBind, _mdfMobileBind as mdfMobileBind, _bind_mdf_identity as bind_mdf_identity, _setMobilePassword as setMobilePassword, _verifyQrSession as verifyQrSession, _getOmronToken as getOmronToken, _providerBinding as providerBinding, _providerLogin as providerLogin, _getHasuraToken as getHasuraToken, _deactivateAccount as deactivateAccount, session_exports };